module.exports = __webpack_public_path__ + "static/img/starry-sky-1920.6729f64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Scenes/StarSkyBg/img/bg/starry-sky-1920.jpg
// module id = 34
// module chunks = 0